export enum CellEnum {
  Drawer = 0,
  Pn = 1,
  ChineseName = 2,
  Description = 3,
  Quantity = 4,
  Image = 5,
}
